import { APP_NAME } from "@constants/app.constants";
import { useEffect } from "react";

const LoginWrapperComponent = ({ children }) => {
  useEffect(() => {
    document.body.style.zoom = "90%";
  }, []);
  return (
    <div className="blank-page">
      <div className="app-content content ">
        <div className="content-overlay"></div>
        <div className="header-navbar-shadow"></div>
        <div className="content-wrapper">
          <div className="content-header row"></div>
          <div className="content-body">
            <div className="auth-wrapper auth-basic px-2">
              <div className="auth-inner my-2">
                <div className="card mb-0">
                  <div className="card-body">
                    <a href="#/" className="brand-logo">
                      <h2 className="brand-text text-primary">{APP_NAME}</h2>
                    </a>

                    <h4 className="card-title mb-1">
                      Welcome to {APP_NAME}! 👋
                    </h4>
                    <p className="card-text mb-2">
                      Please sign-in to your account and start the adventure
                    </p>
                    {children}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginWrapperComponent;
